import { baseQueries, baseMutations } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/environments/graphql/resolvers/base.js?vue3';
import { kubernetesQueries, kubernetesMutations } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/environments/graphql/resolvers/kubernetes/index.js?vue3';
import { fluxQueries, fluxMutations } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/environments/graphql/resolvers/flux.js?vue3';

export const resolvers = (endpoint) => ({
  Query: {
    ...baseQueries(endpoint),
    ...kubernetesQueries,
    ...fluxQueries,
  },
  Mutation: {
    ...baseMutations,
    ...kubernetesMutations,
    ...fluxMutations,
  },
});
